<template>
  <div>
    <label :for="$attrs.id" class="a-select-label"><slot></slot></label>
    <a-select
      :id="$attrs.id"
      :options="options"
      :selectedOptionIds="assigneeIds"
      bind-by-object
      :multiselect="true"
      compress
      @input="createAssignee"
      @destroy="destroyAssignee"></a-select>

    <template v-for="permittee in permittees">
      <pill :class="tagClasses(permittee)" full
            @onRemove="permittee.destroy()"
            :value="permittee.display"
      >
        <template #suffix v-if="permittee.legacyConfigTooltip">
          <button type="button" class="btn-icon" v-tooltip="permittee.legacyConfigTooltip">
            <icon class="exclamation"></icon>
            <span class="sr-only">{{ permittee.legacyConfigTooltip }}</span>
          </button>
        </template>
      </pill>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {TVOptionSet} from "~/interfaces/vSelectInterfaces";
import { PermitteeType } from "~/enums/permitteeType";
import assignableMixin from "~/mixins/assignableMixin";
import {TagColor} from "~/enums/tagColor";
import {IPermittee} from "~/interfaces/permitteeInterfaces";

export default Vue.extend({
  inheritAttrs: false,
  mixins: [assignableMixin],
  props: {
    permittees: {
      type: Array as () => IPermittee[],
    },
    options: {
      type: Array as () => TVOptionSet[],
    }
  },
  data: function() {
    return {
      PermitteeType,
    };
  },
  computed: {
    assigneeIds: {
      get(): string[] {
        return this.permittees.map(it => it.reference_id);
      },
    },
    assigneeCollection(): IPermittee[] {
      return this.permittees;
    },
  },
  methods: {
    createAssignee(option) {
      this.$emit('create', this.getAssigneePropsFromOption(option));
    },
    removeAssignee(assignee: IPermittee) {
      assignee.destroy();
    },
    destroyAllPermittees(): void {
      this.permittees.forEach(it => it.destroy());
    },
    tagClasses(assignee: IPermittee) {
      return {
        [TagColor[assignee.reference_type]]: true,
        [this.$attrs.id]: true,
      };
    }
  },
});
</script>